<div style="width: 100%; height: 0px; position: relative; text-align: left" class="ez-container">
  <iframe
    [src]="safeUrl"
    frameborder="0"
    scrolling="yes"
    style="width: 100%; height: 100%; position: absolute"
    allowfullscreen
  ></iframe>
</div>
